"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MAX_RATING = exports.DEFAULT_RATING = exports.STAR_ICON = exports.RATING_TYPE = void 0;
var RATING_TYPE = {
  COMPACT: 'compact',
  FULL: 'full'
};
exports.RATING_TYPE = RATING_TYPE;
var STAR_ICON = {
  SELECTED: 'StarIcon',
  HALF: 'StarHalfIcon',
  EMPTY: 'StarBorderIcon'
};
exports.STAR_ICON = STAR_ICON;
var DEFAULT_RATING = {
  TYPE: RATING_TYPE.FULL,
  SIZE: 'normal',
  COLOR: 'yellow'
};
exports.DEFAULT_RATING = DEFAULT_RATING;
var DEFAULT_MAX_RATING = 5;
exports.DEFAULT_MAX_RATING = DEFAULT_MAX_RATING;